import React from "react";

import { Layout, Spinner } from "@/components/ui";

const ColumnLoading = () => (
  <Layout.Main>
    <div className="px-4 py-6" aria-live="polite" aria-busy="true">
      <Spinner />
    </div>
  </Layout.Main>
);

export default ColumnLoading;
